import { Box, styled } from '@mui/material';

// Cabecera fija del panel: título + contador a la izquierda, acciones a la derecha.
const StyledNotificationHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.hairline.main}`,
  columnGap: theme.spacing(1),
  display: 'flex',
  flex: 'none',
  justifyContent: 'space-between',
  padding: theme.spacing(1.75, 1.25, 1.75, 2)
}));

export default StyledNotificationHeader;
